export default {
  data() {
    return {
      isFixed: false,
      offsetTop: 0,
      btnBoxWidth: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScrollPage)
    window.addEventListener('resize', this.handleResizePage)
  },
  beforeUpdate() {
    this.$nextTick(() => {
      this.offsetTop = document.querySelector('.btn_box').offsetTop
      this.btnBoxWidth = document.querySelector('.detail_t_box').offsetWidth
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollPage)
    window.removeEventListener('resize', this.handleResizePage)
  },
  methods: {
    handleScrollPage() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.isFixed = scrollTop - 122 > this.offsetTop ? true : false
    },
    handleResizePage() {
      this.$nextTick(() => {
        this.offsetTop = document.querySelector('.btn_box').offsetTop
        this.btnBoxWidth = document.querySelector('.detail_t_box').offsetWidth
      })
    },
  }
}